"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _row = _interopRequireDefault(require("../row/row.style"));

var _column = _interopRequireDefault(require("../row/column/column.style"));

var _inputPresentation = _interopRequireDefault(require("../../__internal__/input/input-presentation.style"));

var _label = require("../../__internal__/label/label.style");

var _base = _interopRequireDefault(require("../../style/themes/base"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const spacings = {
  none: 0,
  "extra-small": 8,
  small: 16,
  "medium-small": 20,
  medium: 24,
  "medium-large": 28,
  large: 32,
  "extra-large": 40
};
const StyledInlineInputs = _styledComponents.default.div`
  display: flex;
  align-items: center;

  ${({
  inputWidth
}) => inputWidth && `
    flex: 0 0 ${inputWidth}%;
  `}

  ${_label.StyledLabelContainer} {
    margin-bottom: 0;
    padding-right: 16px;
    width: ${({
  labelWidth
}) => labelWidth ? `${labelWidth}%` : "auto"};
  }

  input {
    width: 1px;
  }

  [data-component="carbon-select"] input {
    width: 30px;
  }

  ${_row.default} {
    flex-grow: 1;
  }

  ${({
  gutter
}) => (0, _styledComponents.css)`
      ${_row.default} {
        margin-bottom: 0;
        margin-left: -${spacings[gutter]}px;

        > ${_column.default} {
          margin-bottom: 0;
          padding-left: ${spacings[gutter]}px;
        }
      }

      ${gutter === "none" && (0, _styledComponents.css)`
        ${_column.default} + ${_column.default} ${_inputPresentation.default} {
          border-left: none;
        }
      `}
    `}
`;
StyledInlineInputs.defaultProps = {
  theme: _base.default
};
var _default = StyledInlineInputs;
exports.default = _default;